module.exports = __webpack_public_path__ + "img/17b)(NH Hotel Frankfurt) Montage der Gästezimmer und öffentlichen Bereiche.jpg";